import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-add-documents",
  templateUrl: "./admin-add-documents.component.html",
  styleUrls: ["./admin-add-documents.component.css"],
})
export class AdminAddDocumentsComponent implements OnInit {
  docForm: FormGroup;
  loading: boolean = false;
  token: any;
  EditMode: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminAddDocumentsComponent>,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private service: AdminService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.docForm = this.formBuilder.group({
      docName: [
        "",
        [Validators.required, Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$")],
      ],
      module: ["", Validators.compose([Validators.required])],
      docRequired: [false],
      // docStatus: [""],
    });
    this.token = localStorage.getItem("adminToken");
    if (this.data) {
      this.EditMode = true;
      this.docForm.patchValue({
        docName: this.data.document_name,
        module: this.data.module,
        docRequired: this.data.document_required,
      });
    }
  }

  close() {
    this.matdialogref.close();
  }

  public get DocFormControl() {
    return this.docForm.controls;
  }

  public SubmitDoc() {
    if (this.docForm.valid) {
      this.loading = true;
      let docData = {
        document_name: this.docForm.value.docName,
        module: this.docForm.value.module,
        document_required: this.docForm.value.docRequired,
      };
      this.service.PostDocument(docData, this.token).subscribe(
        (response: any) => {
          if (
            (response.status == 201 && response.status == 200) ||
            response.body.data
          ) {
            this.matdialogref.close({ event: "Success" });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
      this.loading = false;
    } else {
      this.snackBar.open("Please Enter valid Document Data", "Fail", {
        duration: 5000,
      });
    }
  }

  public UpdateDoc() {
    if (this.docForm.valid) {
      this.loading = true;
      let docData = {
        document_name: this.docForm.value.docName,
        module: this.docForm.value.module,
        document_required: this.docForm.value.docRequired,
      };
      this.service.UpdateDocument(docData, this.token, this.data._id).subscribe(
        (response: any) => {
          if (response.status == 200 || response.body.data) {
            this.matdialogref.close({ event: "Success" });
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
      this.loading = false;
    } else {
      this.snackBar.open("Please Enter valid Document Data", "Fail", {
        duration: 5000,
      });
    }
  }
}
